import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import FinePrintLinks from "../Footer/FinePrintLinks";

@inject("FooterStore")
@observer
class FooterSmall extends Component {
  render() {
    const { FooterStore } = this.props;
    return (
      <footer className="nw-footersmall-wrapper">
        <FinePrintLinks.component store={FooterStore} />
      </footer>
    );
  }
}

FooterSmall.wrappedComponent.propTypes = {
  FooterStore: PropTypes.shape({}).isRequired,
};

const getFinalComponent = component =>
  inject("FooterStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: FooterSmall.wrappedComponent,
  component: FooterSmall,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/FooterSmall/index.js